<template>
  <div>
    <!-- Výpis ZAC-->

    <table
      v-for="(item, index) in TiskHkLhcJprlVybPrint"
      :key="index"
      class="HkBasicTbl CB_VypisLhpo"
    >
      <thead>
        <tr class="HkBasicTr1">
          <td class="HkBasicTd HkCr HkFs10">
            © Národní lesnický institut, Brandýs nad Labem
          </td>
        </tr>
        <tr class="HkBasicTr1">
          <!-- porost -->
          <td class="HkBasicTd" v-html="item.Vypis" />
        </tr>
      </thead>
      <tbody>
        <!-- jprl -->
        <tr
          class="HkBasicTr2"
          v-for="(item2, index2) in item.SeznamJprl"
          :key="index2"
        >
          <td class="HkBasicTd" v-html="item2" />
        </tr>
      </tbody>
    </table>

    <!-- Výpis KON -->
  </div>
</template>

<script>
export default {
  props: {
    // Tisk HK - celkový seznam Jprl
    TiskHkLhcJprlVybPrint: { type: Object },
  },

  data() {
    return {};
  },

  watch: {},
};
</script>